import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.146 4.993a8 8 0 0 1 5.262-.87 1 1 0 0 0 .35-1.969A10.008 10.008 0 0 0 6.345 20.26a1 1 0 1 0 1.132-1.649 8.01 8.01 0 0 1 .669-13.618m9.324-1.365a1 1 0 1 0-1.095 1.674 8.008 8.008 0 0 1-5.928 14.559 1 1 0 0 0-.386 1.962A10.007 10.007 0 0 0 17.47 3.628m-4.121 10.664.29.792a1 1 0 1 0 1.878-.69l-2.293-6.246c-.446-1.214-2.17-1.197-2.591.027l-2.147 6.24a1 1 0 0 0 1.891.65l.266-.773zm-.735-2-.662-1.804-.62 1.804z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: r };
export {
  d as default,
  r as render
};
//# sourceMappingURL=ic_automatic-xm6TaA52.js.map
